module.exports = __webpack_public_path__ + "ba01283dc7d84468bad8e21cb871e062.jpg";